// import SideBar from "../side-bar/side-bar";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import AppContext from "./services/app-context-services";
// @ts-ignore
import styles from "./app-component.module.scss";
import { Category } from "./models/home-rows";
import { Profile } from "./models/login";
import { SeoModel } from "./models/seo";
import FetchData from "./modules/shared/fetch-data/fetch-data";
import AppMainFooter from "./modules/shared/main-footer/main-footer.component";
import AppNotification from "./modules/shared/notification/app-notification";
import AppSearch from "./modules/shared/search/search.component";
import { API } from "./services/api-services";
import { postAvLog } from "./services/player-service";
import { _c } from "./services/text-services";
import useWindowWidth from "./services/window-width-hook";
import AppLoginPopup2 from "./modules/auth/components/login/login2-popup.component";
import Footer from "./modules/blog/feature-list/footer/footer";
import { ROOT_CATEGORIES_ID } from "./modules/details/models/detail-page";
import FetchDgIdFcmToken from "./components/fetch-dgid-fcm-token/fetch-dgid-fcm-token";
import { setUTMCookies } from "./services/cookie-service";
import "animate.css";
import FooterApp from "./modules/shared/footer/footer";
import Header from "./modules/shared/header2/header";
import Navbar from "./modules/shared/header2/navbar";
import CustomHeader from "./modules/shared/header2/customHeader";

interface LayoutProps {
  showHeader: boolean;
  showCustomHeader?: boolean;
  showFooter?: boolean;
  isBlog?: boolean;
  whiteBackground?: boolean;
  usePaddingInsteadOfMargin?: boolean;
  isSSR?: boolean;
  children: any;
  seoModel?: SeoModel;
  isNavbar?: boolean;
  hideNavbar ?: boolean;
  isTransparentHeader?: boolean;
}
export type ShowMobileOverlay = "menu" | "category" | "profile" | null;

function AppRoot({
  children,
  showHeader,
  usePaddingInsteadOfMargin,
  isBlog = false,
  whiteBackground,
  isNavbar,
  hideNavbar,
  isTransparentHeader,
  showCustomHeader
}: LayoutProps) {
const appCtx = useContext(AppContext);
  const { isMobile } = useWindowWidth();
  const catId = isBlog
    ? ROOT_CATEGORIES_ID.blog
    : Number(process.env.NEXT_PUBLIC_ALL_CAT_ID) || 0;
  const [showMobileOverlay, setShowMobileOverlay] =
    useState<ShowMobileOverlay>(null);
  const [syncStateTokens, setSyncStateTokens] = useState(false);
  const {
    showFixedSearch,
    showLoginPopup,
    isIntlUser,
    setShowLoginPopup,
    dg_id,
    token,
    setProfile,
    isLoggedIn
  } = appCtx;
  const [categories, setCategories] = useState<Category[]>([]);
  const [fetchCategories, setFetchCategories] = useState(false);
  const [isForcedNoHeader, setIsForcedNoHeader] = useState(false);
  const [fetchProfile, setFetchProfile] = useState(false);
  const router = useRouter();
  const paddingOrMargin = usePaddingInsteadOfMargin ? "padding" : "margin";
  const DesktopHeaderBlog = dynamic(
    () => import("./modules/blog/header/desktop-header"),
    { ssr: false }
  );
  const MobileHeaderBlog = dynamic(
    () => import("./modules/blog/header/mobile-header"),
    { ssr: false }
  );

  // const Header = dynamic(
  //   () => import("./modules/shared/header2/header"),
  //   { ssr: false }
  // );
  // const FooterApp = dynamic(
  //   () => import("./modules/shared/footer/footer"),
  //   { ssr: false }
  // );

  useEffect(() => {
    if (!router.isReady) return;
    const { utm_campaign, utm_medium, utm_source, no_headers } = router.query;
    setUTMCookies(
      utm_campaign as string,
      utm_medium as string,
      utm_source as string
    );

    no_headers && setIsForcedNoHeader(true);
  }, [router.query]);

  useEffect(() => {
    appCtx.syncStateTokens();
    const timeout = setTimeout(() => {
      setSyncStateTokens(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [router, token]);

  useEffect(() => {
    if (!syncStateTokens || !router.isReady) return;
    let localAvLog = window.localStorage.getItem("avLog");
    if (!localAvLog || !router?.route) return;
    postAvLog(localAvLog, dg_id, token);
  }, [router, token, syncStateTokens]);

  useEffect(() => {
    isLoggedIn && setFetchProfile(true);
  }, [isLoggedIn]);

  return (
    <>
      {/* {get profile} */}
      {fetchProfile && (
        <FetchData
          url={API.request_profile_with_active_subs}
          method="GET"
          onSuccessful={data => {
            const castData = data as Profile;
            setProfile(castData);
          }}
          with_dg_id
          showClientSideError
        />
      )}

      {/* {get digi_id if not exists} */}
      <FetchDgIdFcmToken counter={1} />

      {fetchCategories && (
        <FetchData
          url={API.request_category(catId)}
          method="GET"
          onSuccessful={data => setCategories(data as Category[])}
          unAuthorized
          with_dg_id
        />
      )}
      {!isForcedNoHeader && !isBlog && showHeader && (
        <Header isTransparentHeader={isTransparentHeader} />
        /* {!isMobile ? (
            <DesktopHeader
              showMenuSearch={show => setShowFixedSearch(show)}
              categories={categories}
              fetchCategories={() => setFetchCategories(true)}
            />
          ) : (
            <MobileHeader
              showMobileOverlay={showMobileOverlay}
              setShowMobileOverlay={state => setShowMobileOverlay(state)}
              showMenuSearch={setShowFixedSearch}
              categories={categories}
              fetchCategories={() => setFetchCategories(true)}
            />
          )} */
      )}
      {!isForcedNoHeader && isBlog && showHeader && (
        <>
          {!isMobile ? (
            <DesktopHeaderBlog
              categories={categories}
              fetchCategories={() => setFetchCategories(true)}
            />
          ) : (
            <MobileHeaderBlog
              categories={categories}
              fetchCategories={() => setFetchCategories(true)}
            />
          )}
        </>
      )}
      {showFixedSearch && (
        <>
          <div className={_c(styles, "mt-5 search-section desktop")}>
            <AppSearch isMenu />
          </div>
          <div className={_c(styles, "mt-5 search-section mobile")}>
            <AppSearch isMenu isMobile />
          </div>
        </>
      )}
      <main
        style={{
          backgroundColor: isBlog && !whiteBackground ? "#F9FAFC" : "none",
          paddingBottom : hideNavbar && 0
        }}
        className={`${isTransparentHeader && styles.withTransparent} ${_c(
          styles,
          "main-section " +
            (!isForcedNoHeader && (showHeader || showCustomHeader)
              ? `main-section-${"padding"}`
              : `main-section-${paddingOrMargin}-in-player `)
        )}`}
      >
        {children}
        {showMobileOverlay && (
          <div
            onClick={() => setShowMobileOverlay(null)}
            className={_c(styles, "show-mobile-menu-layer")}
          ></div>
        )}
      </main>
      {showLoginPopup && (
        <AppLoginPopup2 onClose={() => setShowLoginPopup(false)} />
      )}
      {/* {!isForcedNoHeader && showHeader && !isBlog && <AppMainFooter />} */}
      {!isForcedNoHeader && !isBlog && (showHeader || showCustomHeader) && (
        <FooterApp isNavbar={isNavbar} />
      )}
      {!isForcedNoHeader && (showHeader || showCustomHeader) && isBlog && (
        <Footer />
      )}
      {isIntlUser === false  && !hideNavbar && <Navbar />}
      <AppNotification />
    </>
  );
}

export default AppRoot;
